import React from 'react';

const ExternalLinkIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
  </svg>
);

const DownloadIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
);

const DocumentIcon = () => (
  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const warrantyDocuments = [
  {
    title: 'V-Track Warranty Information',
    description: 'Full warranty terms and coverage details for V-Track products',
    url: '/documents/Warranty.pdf',
    type: 'PDF',
    downloadName: 'VTrack_Warranty.pdf',
  },
];

export const WarrantyTermsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-white">Warranty Terms & Documents</h1>
        <p className="text-gray-400 mt-1">
          Warranty information and coverage details for all products
        </p>
      </div>

      {/* Documents Grid */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {warrantyDocuments.map((doc) => (
          <div
            key={doc.url}
            className="card p-6 hover:border-keder-yellow transition-colors group"
          >
            <div className="flex items-start gap-4">
              <div className="text-gray-400 group-hover:text-keder-yellow transition-colors">
                <DocumentIcon />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-white font-medium group-hover:text-keder-yellow transition-colors">
                  {doc.title}
                </h3>
                <p className="text-gray-400 text-sm mt-1">{doc.description}</p>
                <div className="flex flex-wrap gap-2 mt-4">
                  <a
                    href={doc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-secondary text-sm flex items-center gap-2"
                  >
                    <ExternalLinkIcon />
                    <span>View PDF</span>
                  </a>
                  <a
                    href={doc.url}
                    download={doc.downloadName}
                    className="btn-secondary text-sm flex items-center gap-2"
                  >
                    <DownloadIcon />
                    <span>Download</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Warranty Coverage Summary */}
      <div className="card p-6 bg-keder-gray/30">
        <h2 className="text-lg font-semibold text-white mb-4">Warranty Coverage Summary</h2>
        <div className="space-y-4 text-gray-300">
          <div>
            <h3 className="text-keder-yellow font-medium mb-1">Keder Screens</h3>
            <p className="text-sm text-gray-400">
              All Keder Screens products are covered under our comprehensive warranty program.
              Please refer to the warranty document above for complete terms and conditions.
            </p>
          </div>
        </div>
      </div>

      {/* Help Section */}
      <div className="card p-6 bg-keder-gray/30">
        <h2 className="text-lg font-semibold text-white mb-2">Warranty Questions?</h2>
        <p className="text-gray-400">
          To file a warranty claim, use Submit RMA in the menu. For questions about warranty coverage, contact our team:
        </p>
        <div className="mt-4 space-y-2">
          <p className="text-gray-300">
            <span className="text-gray-400">Email:</span>{' '}
            <a href="mailto:orders@kederscreens.com" className="text-keder-yellow hover:underline">
              orders@kederscreens.com
            </a>
          </p>
          <p className="text-gray-300">
            <span className="text-gray-400">Phone:</span>{' '}
            <a href="tel:+14699427193" className="text-keder-yellow hover:underline">
              (469) 942-7193
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default WarrantyTermsPage;
